// src/components/subscription/TrialBanner.jsx

import React, { useState, useEffect } from 'react';
import { useSubscription } from '../../context/SubscriptionContext';
import SubscriptionPlans from './SubscriptionPlans';

export default function TrialBanner() {
  const { subscription, getCurrentPlan } = useSubscription();
  const [showPlans, setShowPlans] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!subscription) return;

    const currentPlan = getCurrentPlan();
    
    // Show banner for free plan or expiring subscriptions
    if (currentPlan.id === 'free') {
      setShowBanner(true);
      setDaysRemaining(0);
    } else if (subscription.expiresAt) {
      const now = new Date();
      const expiryDate = subscription.expiresAt.toDate();
      const timeDiff = expiryDate.getTime() - now.getTime();
      const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
      
      if (daysLeft <= 7) { // Show banner in last 7 days
        setShowBanner(true);
        setDaysRemaining(Math.max(0, daysLeft));
      }
    }
  }, [subscription, getCurrentPlan]);

  if (!showBanner) return null;

  if (showPlans) {
    return <SubscriptionPlans onClose={() => setShowPlans(false)} />;
  }

  const currentPlan = getCurrentPlan();
  const isFreePlan = currentPlan.id === 'free';
  const isExpiringSoon = daysRemaining <= 7 && daysRemaining > 0;
  const isExpired = daysRemaining === 0 && currentPlan.id !== 'free';

  return (
    <div style={{
      backgroundColor: isExpired ? '#fef2f2' : isExpiringSoon ? '#fef3c7' : '#e0f2fe',
      borderLeft: `4px solid ${isExpired ? '#ef4444' : isExpiringSoon ? '#f59e0b' : '#0ea5e9'}`,
      padding: '12px 20px',
      margin: '0 32px 16px',
      borderRadius: '0 8px 8px 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      minHeight: '48px',
      maxHeight: '60px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{ fontSize: '24px' }}>
          {isExpired ? '⚠️' : isExpiringSoon ? '⏰' : '🎁'}
        </span>
        <div>
          <div style={{
            fontWeight: '600',
            color: isExpired ? '#dc2626' : isExpiringSoon ? '#d97706' : '#0369a1',
            marginBottom: '4px'
          }}>
            {isFreePlan 
              ? 'Ücretsiz Plan Kullanıyorsunuz'
              : isExpired
                ? 'Aboneliğiniz Sona Erdi'
                : `Aboneliğiniz ${daysRemaining} Gün Sonra Sona Eriyor`
            }
          </div>
          <div style={{
            fontSize: '14px',
            color: isExpired ? '#7f1d1d' : isExpiringSoon ? '#92400e' : '#075985'
          }}>
            {isFreePlan 
              ? 'Daha fazla özellik için planınızı yükseltin'
              : isExpired
                ? 'Hizmetlerinizi kesintisiz kullanmak için aboneliğinizi yenileyin'
                : 'Hizmet kesintisi yaşamamak için aboneliğinizi yenileyin'
            }
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        {!isFreePlan && (
          <div style={{
            fontSize: '12px',
            color: isExpired ? '#7f1d1d' : isExpiringSoon ? '#92400e' : '#075985',
            textAlign: 'right',
            marginRight: '12px'
          }}>
            <div style={{ fontWeight: '600' }}>Mevcut Plan: {currentPlan.name}</div>
            <div>{currentPlan.price}₺/ay</div>
          </div>
        )}

        <button
          onClick={() => setShowPlans(true)}
          style={{
            padding: '8px 16px',
            backgroundColor: isExpired ? '#dc2626' : isExpiringSoon ? '#f59e0b' : '#0ea5e9',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontWeight: '600',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
        >
          {isFreePlan ? 'Planları Görüntüle' : 'Aboneliği Yenile'}
        </button>

        <button
          onClick={() => setShowBanner(false)}
          style={{
            padding: '4px 8px',
            backgroundColor: 'transparent',
            border: 'none',
            color: isExpired ? '#7f1d1d' : isExpiringSoon ? '#92400e' : '#075985',
            cursor: 'pointer',
            fontSize: '18px'
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}